const crud = { c: false, r: false, u: false, d: false };

export const ingestions = Object.freeze({
  ingestion: { ...crud },
  viewLog: { ...crud },
  runIngestion: { ...crud },
});
